export default __webpack_public_path__ + "static/media/Deltagerliste_eksempel.1a62368d.xlsx";